import { useEffect, useRef, useState } from "react";
import React from "react";
import "./HomeDashboard.scss";
import Loader from "../../Loader";
import { BiEdit } from "react-icons/bi";
import axios from "axios";
import TextField from "@mui/material/TextField";
export default function HomeDashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [id, setId] = useState(null);
  const [image, setImage] = useState(null);
  const [profile, setProfile] = useState({
    name: "",
    title: "",
    description: "",
    imageURL: "",
  });

  const inputRef = useRef(null);
  const [inputVisible, setInputVisible] = useState(false);
  async function onClickOutSide(e) {
    console.log(profile);
    if (inputRef.current && !inputRef.current.contains(e.target)) {
    }
  }
  async function handleChange(e) {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    setImage(formData);
  }
  async function save() {
    console.log("hi");
    await axios.put(
      `${process.env.REACT_APP_server}/home/${id}`,
      profile
    );
    setInputVisible(false);
  }

  async function uplodePhoto() {
    await axios
      .put(`${process.env.REACT_APP_server}/home/${id}`, image)
      .then(() => getData());
    console.log(image);
  }
  useEffect(() => {
    if (inputVisible) {
      document.addEventListener("mousedown", onClickOutSide);
    }

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    };
  });
  async function getData() {
    const response = await fetch(`${process.env.REACT_APP_server}/home`);
    var profile = await response.json();
    setProfile(profile);
    setId(profile[0]._id);
    setIsLoading(false);
  }

  useEffect(() => {
    getData();
    uplodePhoto();
    console.log(profile);
  }, [image]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="home_dashboard">
          <div className="alert__save">
            {/* <Stack sx={{ width: '20%' }} spacing={2}>
                    <Alert variant="filled" severity="success">
                      This is a success alert — check it out!
                    </Alert>
                  </Stack> */}
          </div>
          <div class="profile-pic">
            <label class="-label" for="file">
              <span class="glyphicon glyphicon-camera"></span>
              <span>
                <BiEdit />
              </span>
            </label>
            <input id="file" type="file" onChange={handleChange} />
            <img src={profile[0].imageURL} id="output" width="200" />
          </div>
          <h2 className="change_photo_title">Change your Photo</h2>
          <div className="edit__info">
            {inputVisible ? (
              <div>
                <div>
                  <TextField
                    ref={inputRef} // Set the Ref
                    placeholder={"Put a new Name Here"}
                    onChange={(event) => {
                      setProfile({ ...profile, name: event.target.value });
                    }}
                    id="outlined-basic"
                    label="a new name"
                    variant="outlined"
                  />
                </div>
                <div>
                  <TextField
                    ref={inputRef} // Set the Ref
                    placeholder={"Put a new Name title"}
                    onChange={(event) => {
                      setProfile({ ...profile, title: event.target.value });
                    }}
                    id="outlined-basic"
                    label="a new title"
                    variant="outlined"
                  />
                </div>
                <div>
                  <TextField
                    ref={inputRef} // Set the Ref
                    placeholder={"Put a new Name description"}
                    onChange={(event) => {
                      setProfile({
                        ...profile,
                        description: event.target.value,
                      });
                    }}
                    id="outlined-basic"
                    label="a new description"
                    variant="outlined"
                  />
                </div>

                <div>
                  <a onClick={save} class="button primary edit">
                    Save
                  </a>
                </div>
              </div>
            ) : (
              <>
                <span onClick={() => setInputVisible(true)}>
                  <BiEdit className="icon_edit" />
                  Click here to change your information
                </span>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
